<template>
  <div
    class="sort-by fixed top-0 left-0 bottom-0 right-0 w-full h-screen z-100"
  >
    <div
      class="sort-by-shape fade-in fixed top-0 left-0 bottom-0 right-0 w-full h-screen"
      @click="closeSortBy"
    ></div>
    <div
      class="sort-by-data slide-in-bottom w-full left-0 bottom-0 right-0 absolute bg-white px30"
      :class="{ 'slide-out-bottom': close }"
    >
      <span class="close" @click="closeSortBy"><Close icon="close" /></span>
      <p class="text-center text-text text-16 font-bold mb-6">
        {{ $t("Sort results by") }}
      </p>
      <ul class="pb-8">
        <li
          class="flex justify-between mb-2"
          v-for="item in sortData"
          :key="item.id"
        >
          <label
            :for="`${item.id}-sortBy-${item.id}`"
            class="font-bold text-14"
            
          >
            {{ item.title }}
          </label>
          <span>
            <input
              :id="`${item.id}-sortBy-${item.id}`"
              type="radio"
              class="input-checkbox"
              v-model="sortPicked"
              :value="item.value"
              @change="sortByHandler"
            />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Close from "../UI/Close.vue";
export default {
  name: "SortBy",

  props: {
    sortBy: {
      default: ""
    }
  },

  components: {
    Close
  },

  data: function() {
    return {
      sortPicked: "",
      close: false,
      sortData: [
        {
          id: 2,
          title: this.$t("Distance"),
          value: "distance"
        },
        {
          id: 3,
          title: this.$t("Rating"),
          value: "rating"
        },
        {
          id: 4,
          title: this.$t("Best discount"),
          value: "discount"
        }
      ]
    };
  },

  mounted() {
    this.sortPicked = this.sortBy;
  },

  methods: {
    closeSortBy: function() {
      this.close = true;
      setTimeout(() => {
        this.$emit("closeSortBy");
      }, 500);
    },
    sortByHandler: function() {
      this.close = true;
      setTimeout(() => {
        this.$emit("closeSortBy", this.sortPicked);
      }, 500);
    }
  }
};
</script>
